import './featureCarousel.scss';
import { BaseComponent } from '../baseComponent';
import { ComponentEvents } from '../../models/events';
import { Carousel } from '@/modules/carousel/carousel';
import { VideoPlayer } from '@/modules/videoPlayer';

export default class extends BaseComponent {
  private carousel: Carousel | null = null;
  private activeVideoPlayer: VideoPlayer | null = null;

  constructor(el: HTMLElement) {
    super(el);
    this.visibleTrigger = 20;
    this.el.addEventListener(ComponentEvents.READY, this.init.bind(this));
  }

  public init() {
    if (!this.el.dataset.spy) {
      this.revealElement();
    }

    const itemCount = parseInt(this.el.dataset.itemCount || '1');
    itemCount > 1 && this.renderCarousel();

    this.setActiveVideoPlayer();

    this.carousel?.swiper.on('slideChange', () => this.setActiveVideoPlayer());
  }

  private setActiveVideoPlayer(): void {
    this.activeVideoPlayer?.stop();
    const context = this.carousel ? this.carousel.activeSlide : this.el;
    const videoContext = context.querySelector('.media-video');
    if (
      videoContext &&
      videoContext.firstElementChild?.tagName.toLowerCase() !== 'iframe'
    ) {
      this.activeVideoPlayer = new VideoPlayer(videoContext);
    }
  }

  private renderCarousel(): void {
    this.carousel = new Carousel(this.el, {
      speed: 500,
      simulateTouch: false,
      pagination: {
        el: '.nav-pagination',
        type: 'fraction',
      },
    });
  }
}
